import React from 'react';

export interface ClinicalBrandMarkProps {
  size?: number;
  className?: string;
  variant?: 'mark' | 'full';
  alt?: string;
}

/**
 * ClinicalBrandMark
 * Primary brand mark component for the Pulse clinical application.
 * Renders the new stylized bloom brand mark crisply and calmly with exact aspect ratio
 * and vector fidelity, without 3D animation, spinning, glowing, or shimmering.
 */
export const ClinicalBrandMark: React.FC<ClinicalBrandMarkProps> = ({
  size = 38,
  className = '',
  variant = 'mark',
  alt = 'Bloom Logo'
}) => {
  return (
    <div
      className={`inline-flex items-center justify-center shrink-0 select-none ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={alt}
    >
      <img
        src="/brand/canonical/bloom-header.png"
        alt={alt}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="w-full h-full object-contain select-none pointer-events-none"
      />
    </div>
  );
};
